import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {IdentificationData} from "../../data/models/identification-data.model";
import {Person} from "../../data/models/person.model";
import {Address} from "../../data/models/address.model";

/**
 * Transportform von {@link IdentificationData}: Map-Felder werden zu Plain-Objekten, weil
 * JSON.stringify eine Map zu {} serialisiert und die Werte sonst still verloren gehen.
 */
type IdentificationRequestBody = Omit<IdentificationData, 'extendedData' | 'maskedExtendedData'> & {
  extendedData: Record<string, string>;
  maskedExtendedData: Record<string, string>;
};

@Injectable({
  providedIn: 'root'
})
export class IdentificationService {
  private http = inject(HttpClient);



  checkUserAndGetMaskedExtendedData(data: IdentificationData): Observable<IdentificationData>{
    return this.http.post<IdentificationData>('/webabo/users/checkUserAndGetMaskedExtendedData', this.toRequestBody(data)).pipe(map( (identification: any) => {
      if (identification) {
        identification = this.buildObject(identification);
        return identification;
      } else {
        return null;
      }
    }));
  }

  checkUserAndValidateExtendedData(data: IdentificationData): Observable<IdentificationData>{
    return this.http.post<IdentificationData>('/webabo/users/checkUserAndValidateExtendedData', this.toRequestBody(data)).pipe(map( (identification: any) => {
      identification = this.buildObject(identification);
      return identification;
    }));
  }

  createAccount(data: IdentificationData): Observable<IdentificationData>{
    return this.http.post<IdentificationData>('/webabo/users/createAccount', this.toRequestBody(data)).pipe(map( (identification: any) => {
      identification = this.buildObject(identification);
      return identification;
    }));
  }

  private toRequestBody(data: IdentificationData): IdentificationRequestBody {
    return {
      ...data,
      extendedData: IdentificationService.mapToObject(data.extendedData),
      maskedExtendedData: IdentificationService.mapToObject(data.maskedExtendedData),
    };
  }

  private static mapToObject(source: Map<string, string>): Record<string, string> {
    const target: Record<string, string> = {};
    source?.forEach((value: string, key: string) => {
      target[key] = value;
    });
    return target;
  }

  private buildObject(identification: any) {
    identification.person = new Person(identification.person.title, identification.person.salutation, identification.person.firstname, identification.person.lastname, identification.person.initials, identification.person.middleName);
    identification.address = new Address(identification.address.street, identification.address.houseno, identification.address.zipcode, identification.address.city, identification.address.country, identification.address.webId, identification.address.backendId, identification.address.userBackendId, identification.address.userSSOId, identification.address.district, identification.address.longitude, identification.address.latitude);
    const maskedExtendedData = new Map<string, string>();
    if (identification.maskedExtendedData.EMAIL) {
      maskedExtendedData.set('EMAIL', identification.maskedExtendedData.EMAIL);
    }
    if (identification.maskedExtendedData.IBAN) {
      maskedExtendedData.set('IBAN', identification.maskedExtendedData.IBAN);
    }
    if (identification.maskedExtendedData.PHONE) {
      maskedExtendedData.set('PHONE', identification.maskedExtendedData.PHONE);
    }
    if (identification.maskedExtendedData.BIRTHDAY) {
      maskedExtendedData.set('BIRTHDAY', identification.maskedExtendedData.BIRTHDAY);
    }
    if(identification.maskedExtendedData.CLIENTNO) {
      maskedExtendedData.set('CLIENTNO', identification.maskedExtendedData.CLIENTNO);
    }
    identification.maskedExtendedData = maskedExtendedData;
    return identification;
  }
}
